import { useTranslation } from 'react-i18next';
import { Button, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useDeleteAllAdditionalCostsFromTrip } from 'api/additional-cost/use-delete-all-additional-costs-from-trip';
import styles from './trip-delete-all-additional-costs.module.scss';
import type { ITripDeleteAllAdditionalCostsProps } from './types';

export const TripDeleteAllAdditionalCosts = (props: ITripDeleteAllAdditionalCostsProps) => {
  const { tripId } = props;
  const { t } = useTranslation();

  const { mutateAsync: deleteAllAdditionalCostsFromTrip, isLoading } = useDeleteAllAdditionalCostsFromTrip(tripId);

  const [modal, contextHolder] = Modal.useModal();

  const confirm = () => {
    modal.confirm({
      title: t('common:delete'),
      icon: <ExclamationCircleOutlined />,
      content: t('common:delete_confirm_text'),
      okText: t('common:delete'),
      cancelText: t('common:cancel'),
      onOk: async () => {
        await deleteAllAdditionalCostsFromTrip(tripId);
      },
    });
  };
  return (
    <>
      {contextHolder}
      <Button disabled={isLoading} type='primary' className={styles.deleteCostsButton} danger onClick={confirm}>
        {t('additional-cost:delete_all_additional_costs')}
      </Button>
    </>
  );
};
